// quantity-grid.js — Radio Grid 生成 + 动态价格 + Save% (BD §1.4 + §2.3 + §H2 + PRICING_TABLE §4)
//
// Save% 公式 (PRICING_TABLE §4):
//   savePct(qty, tier) = (1 - unitPrice(qty, tier) / unitPrice(50, tier)) × 100%
//   baseline = 同 tier 50 dots 单价 (NOT cross-tier)

(function () {
  var QTY_TIERS = [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000, 10000];
  var DEFAULT_QTY = 1000;
  var MOST_POPULAR_QTY = 1000;

  function whenReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function findVariant(variants, qty, tier) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (String(v.option1) === String(qty) && String(v.option2) === String(tier)) {
        return v;
      }
    }
    return null;
  }

  whenReady(function () {
    var grid = document.getElementById('quantity-radio-grid');
    var product = window.__MOCK_PRODUCT__;
    if (!grid || !product || !product.variants) {
      console.error('[quantity-grid] missing grid or mock product');
      return;
    }
    var variants = product.variants;
    var selectedQty = DEFAULT_QTY;

    function getCurrentTier() {
      return window.__CURRENT_TIER__ || '1.0';
    }

    function getCurrentVariant(qty) {
      return findVariant(variants, qty, getCurrentTier());
    }

    function getMarketCurrency() {
      return (window.StickerConfig && window.StickerConfig.marketCurrency) || 'USD';
    }

    // VC-010-A: totals display Shopify's own formatted text (priceDisplay) verbatim.
    // No symbol concatenation, no currency conversion, no Intl on the total.
    function formatTotal(v) {
      if (!v) return '—';
      if (v.priceDisplay != null) return v.priceDisplay;
      if (v.priceMinor != null) {
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: getMarketCurrency() })
            .format(v.priceMinor / 100);
        } catch (e) { /* fall through to '—' */ }
      }
      return '—';
    }

    // VC-010-A: /ea unit price = priceMinor / 100 / qty (minor → major, then per unit),
    // formatted with Intl in the market currency.
    function formatUnitPrice(v, qty) {
      if (!v || v.priceMinor == null || !qty) return '';
      var unit = v.priceMinor / 100 / qty;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: getMarketCurrency() }).format(unit);
      } catch (e) {
        return unit.toFixed(2);
      }
    }

    function calcSavePct(qty, tier) {
      var baselineVariant = findVariant(variants, 50, tier);
      var currentVariant = findVariant(variants, qty, tier);
      if (!baselineVariant || !currentVariant) return 0;
      if (baselineVariant.priceMinor == null || currentVariant.priceMinor == null) return 0;
      var baselineUnit = baselineVariant.priceMinor / 100 / 50;
      var currentUnit = currentVariant.priceMinor / 100 / qty;
      return Math.round((1 - currentUnit / baselineUnit) * 100);
    }

    function renderGrid() {
      grid.innerHTML = '';
      var tier = getCurrentTier();
      QTY_TIERS.forEach(function (qty) {
        var variant = findVariant(variants, qty, tier);
        var savePct = calcSavePct(qty, tier);

        var row = document.createElement('label');
        row.className = 'radio-row';
        if (qty === selectedQty) row.classList.add('is-selected');
        if (qty === MOST_POPULAR_QTY) row.classList.add('is-most-popular');
        row.setAttribute('data-qty', qty);
        if (variant) row.setAttribute('data-variant-id', variant.id);

        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'quantity';
        radio.value = qty;
        if (qty === selectedQty) radio.checked = true;

        var qtyCell = document.createElement('span');
        qtyCell.className = 'qty-cell';
        qtyCell.innerHTML = '<span class="qty-number">' + qty.toLocaleString() + '</span> Labels';

        var totalCell = document.createElement('span');
        totalCell.className = 'total-cell';
        totalCell.setAttribute('data-price-slot', '');
        totalCell.textContent = formatTotal(variant);

        var saveCell = document.createElement('span');
        saveCell.className = 'save-cell';
        if (qty === 50) {
          saveCell.classList.add('is-baseline');
          saveCell.textContent = 'Baseline';
        } else {
          saveCell.classList.add('has-discount');
          var unitStr = formatUnitPrice(variant, qty);
          saveCell.innerHTML = 'Save ' + savePct + '%' +
            (unitStr ? '<span class="unit-price">' + unitStr + '/ea</span>' : '');
        }

        if (qty === MOST_POPULAR_QTY) {
          var badge = document.createElement('span');
          badge.className = 'most-popular-badge';
          badge.textContent = 'Recommended';
          row.appendChild(badge);
        }

        row.appendChild(radio);
        row.appendChild(qtyCell);
        row.appendChild(totalCell);
        row.appendChild(saveCell);
        grid.appendChild(row);

        row.addEventListener('click', function () {
          selectedQty = qty;
          // VC-010-A regression fix: the single #total-price writer must
          // run on click too (the old second writer in liquid is gone).
          updateTotalPrice();
          window.dispatchEvent(new CustomEvent('quantity-changed', { detail: { qty: qty } }));
          var allRows = grid.querySelectorAll('.radio-row');
          allRows.forEach(function (r) { r.classList.remove('is-selected'); });
          row.classList.add('is-selected');
        });
      });

      updateTotalPrice();
    }

    function updateTotalPrice() {
      var v = getCurrentVariant(selectedQty);
      var totalEl = document.getElementById('total-price');
      if (totalEl) {
        totalEl.textContent = formatTotal(v);
      }
    }

    window.addEventListener('tier-changed', function () {
      renderGrid();
    });

    window.__QUANTITY_GRID__ = {
      getSelectedQty: function () { return selectedQty; },
      getSelectedVariant: function () { return getCurrentVariant(selectedQty); },
      setSelectedQty: function (qty) { selectedQty = qty; renderGrid(); },
      renderGrid: renderGrid
    };

    renderGrid();
  });
})();
